import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import Loader from "../common/Loader";
import Button from "../common/Button";
import Modal from "../common/Modal";
import EmptyState from "../common/EmptyState";
import { getMediaLikedUsers, getMediaDownloadedUsers } from "../../services/historyService";
import { color } from "../../styles/theme";

/**
 * Who-liked / who-downloaded drill-down — ported from mobile's
 * downloaded-participants screen (src/Screens/downloaded-participants).
 * Shared modal for both engagement types since the list UI is identical,
 * only the fetch + name field differ.
 */
const MediaEngagementUsersModal = ({ mediaId, type, onClose }) => {
  const { t } = useTranslation(["events", "common"]);
  const isLiked = type === "liked";
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = isLiked ? getMediaLikedUsers(mediaId) : getMediaDownloadedUsers(mediaId);
    fetch
      .then((res) => setItems(res.items))
      .catch(() => toast.error(isLiked ? t("mediaEngagementUsersModal.toasts.loadLikedFailed") : t("mediaEngagementUsersModal.toasts.loadDownloadedFailed")))
      .finally(() => setLoading(false));
  }, [mediaId, isLiked, t]);

  return (
    <Modal
      title={isLiked ? t("mediaEngagementUsersModal.likedByTitle") : t("mediaEngagementUsersModal.downloadedByTitle")}
      onClose={onClose}
      maxWidth={380}
      footer={<Button variant="secondary" onClick={onClose}>{t("common:actions.close")}</Button>}
    >
      {loading ? (
        <Loader />
      ) : items.length === 0 ? (
        <EmptyState text={t("mediaEngagementUsersModal.emptyText")} />
      ) : (
        <div style={s.list}>
          {items.map((u, i) => {
            const name = isLiked ? u.Name : u.UserName;
            return (
              <div key={i} style={s.row}>
                {u.ProfilePicture ? (
                  <img src={u.ProfilePicture} alt="" style={s.avatar} />
                ) : (
                  <div style={s.avatarFallback}>{(name || "?").charAt(0).toUpperCase()}</div>
                )}
                <span style={s.name}>{name || t("mediaEngagementUsersModal.unknownName")}</span>
              </div>
            );
          })}
        </div>
      )}
    </Modal>
  );
};

const s = {
  list: { display: "flex", flexDirection: "column", gap: 10 },
  row: { display: "flex", alignItems: "center", gap: 10 },
  avatar: { width: 30, height: 30, borderRadius: "50%", objectFit: "cover" },
  avatarFallback: {
    width: 30, height: 30, borderRadius: "50%", background: color.primary50, color: color.primary600,
    display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: 13,
  },
  name: { fontSize: 13.5, color: color.gray800, fontWeight: 500 },
};

export default MediaEngagementUsersModal;
